import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import RoleSelector from "./pages/RoleSelector";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import TenantGate from "./pages/TenantGate";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import ManagerDashboard from "./pages/ManagerDashboard";
import HRDashboard from "./pages/HRDashboard";
import CompetencyLibrary from "./pages/CompetencyLibrary";
import CareerLadders from "./pages/CareerLadders";
import RetailWorkforce from "./pages/RetailWorkforce";
import RetailEmployeeView from "./pages/RetailEmployeeView";
import RetailManagerView from "./pages/RetailManagerView";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/demo/:slug" element={<TenantGate />} />
          <Route path="/personas" element={<RoleSelector />} />
          <Route path="/employee" element={<EmployeeDashboard />} />
          <Route path="/employee/:tab" element={<EmployeeDashboard />} />
          <Route path="/manager" element={<ManagerDashboard />} />
          <Route path="/manager/:tab" element={<ManagerDashboard />} />
          <Route path="/hr" element={<HRDashboard />} />
          <Route path="/hr/:tab" element={<HRDashboard />} />
          <Route path="/tenant/:slug/library" element={<CompetencyLibrary />} />
          <Route path="/tenant/:slug/career-paths" element={<CareerLadders />} />
          <Route path="/tenant/:slug/workforce" element={<RetailWorkforce />} />
          <Route path="/tenant/:slug/employee/:empId" element={<RetailEmployeeView />} />
          <Route path="/tenant/:slug/manager/:empId" element={<RetailManagerView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
